import { render, staticRenderFns } from "./SideAddList.vue?vue&type=template&id=b906373c&"
import script from "./SideAddList.vue?vue&type=script&lang=js&"
export * from "./SideAddList.vue?vue&type=script&lang=js&"
import style0 from "./SideAddList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports